import { isLocalEnvironment } from "~/utils";

export const openTawkChat = () => {
  try {
    if (
      typeof window !== "undefined" &&
      window?.Tawk_API &&
      window?.Tawk_API?.toggle
    ) {
      window.Tawk_API.toggle();
    }
  } catch (error) {
    if (isLocalEnvironment()) {
      console.log("error", error);
    }
  }
};
